<template>
  <el-dialog
    title="个人信息"
    :visible.sync="innerVisible"
    width="460px"
    append-to-body
    destroy-on-close
    custom-class="user-profile-dialog"
    @closed="onClosed"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item label="用户名">
        <span class="readonly-field">{{ usernameText }}</span>
      </el-form-item>
      <el-form-item label="姓名" prop="display_name">
        <el-input v-model="form.display_name" maxlength="128" show-word-limit placeholder="界面右上角等处的展示名称" />
      </el-form-item>
      <el-divider content-position="left">修改登录密码（可选）</el-divider>
      <el-form-item label="当前密码" prop="current_password">
        <el-input v-model="form.current_password" type="password" show-password autocomplete="off" placeholder="改密时必填" />
      </el-form-item>
      <el-form-item label="新密码" prop="new_password">
        <el-input v-model="form.new_password" type="password" show-password autocomplete="new-password" placeholder="至少 6 位，留空则不修改" />
      </el-form-item>
      <el-form-item label="确认新密码" prop="new_password2">
        <el-input v-model="form.new_password2" type="password" show-password autocomplete="new-password" placeholder="再次输入新密码" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import http from '../api/http'
import { getToken, setAuth } from '../auth/session'

export default {
  name: 'UserProfileDialog',
  props: {
    visible: { type: Boolean, default: false },
    /** 当前 session 用户信息（来自 sessionStorage） */
    user: { type: Object, default: () => null },
  },
  data() {
    const validatePwd2 = (rule, value, callback) => {
      const np = (this.form.new_password || '').trim()
      if (!np) {
        callback()
        return
      }
      if ((value || '').trim() !== np) {
        callback(new Error('两次输入的新密码不一致'))
        return
      }
      callback()
    }
    return {
      innerVisible: false,
      submitting: false,
      form: {
        display_name: '',
        current_password: '',
        new_password: '',
        new_password2: '',
      },
      rules: {
        display_name: [{ max: 128, message: '显示名过长', trigger: 'blur' }],
        new_password: [
          {
            validator(rule, value, callback) {
              const t = (value || '').trim()
              if (t === '') {
                callback()
                return
              }
              if (t.length < 6) {
                callback(new Error('新密码至少 6 位'))
                return
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        new_password2: [{ validator: validatePwd2, trigger: 'blur' }],
      },
    }
  },
  computed: {
    usernameText() {
      const u = this.user
      return (u && u.username) ? String(u.username) : '—'
    },
  },
  watch: {
    visible(v) {
      this.innerVisible = !!v
      if (v) this.syncFromUser()
    },
    innerVisible(v) {
      this.$emit('update:visible', !!v)
    },
  },
  mounted() {
    this.innerVisible = !!this.visible
    if (this.visible) this.syncFromUser()
  },
  methods: {
    syncFromUser() {
      const u = this.user || {}
      this.form = {
        display_name: (u.display_name != null ? String(u.display_name) : '').trim(),
        current_password: '',
        new_password: '',
        new_password2: '',
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate()
      })
    },
    onClosed() {
      this.syncFromUser()
    },
    async submit() {
      const ref = this.$refs.formRef
      try {
        await ref.validate()
      } catch (e) {
        return
      }
      const np = (this.form.new_password || '').trim()
      if (np !== '') {
        if (!(this.form.current_password || '').trim()) {
          this.$message.warning('修改密码时请填写当前密码')
          return
        }
      }
      const payload = {
        display_name: (this.form.display_name || '').trim(),
      }
      if (np !== '') {
        payload.current_password = this.form.current_password
        payload.new_password = np
      }
      this.submitting = true
      try {
        const res = await http.put('/me', payload)
        const nextUser = res.data
        setAuth({ token: getToken(), user: nextUser })
        this.$message.success('已保存')
        this.$emit('saved', nextUser)
        this.innerVisible = false
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped>
.readonly-field {
  color: #606266;
  font-size: 13px;
}
</style>
